export default "__VITE_ASSET__D6Guor07__"